import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>The Importance of Patents in Entrepreneurship</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In Episode 5, Abeer Raza sits with the president of American Patent Agency PC, Mr. Daniar Hussain, and Mr.Stephen Hou, a Patent Prosecution Advisor at APA PC. The duo from APA PC discusses the importance of Patents in the life of an entrepreneur, the process of applying for a patent, and the long-term business benefits of protecting your inventions. So whether you develop software or are the owner of a physical product, you can protect your Intellectual Property and gain the competitive edge you need to find success in your niche.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;